module.exports = __WEBPACK_EXTERNAL_MODULE__uirouter_angularjs__;